import React, { useEffect, useState } from 'react'
import NotFoundPage from '../NotFoundPage'
import { decodeToken } from "react-jwt";
import AdminNav from '../AdminNav';
import axios from "axios";
import "./TopDonators.css";
import { TextField, styled } from '@mui/material';
import Button from '../../Button';

const CssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: 'none',
            boxShadow: 'none',
        },
    },
    '& .MuiInputBase-input': {
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        color: '#ffbb3e'
    }
});

function TopDonators() {
    const { REACT_APP_API_URL } = process.env;

    const token = localStorage.getItem("access_token");
    const decodedToken = decodeToken(token);
    const [topDonators, setTopDonators] = useState([]);

    const onUsernameEdit = (e, i) => {
        setTopDonators((current) => {
            if (e.target.value === '' && current[i].position === '') {
                current.splice(i, 1)
                return [...current];
            }
            current[i] = {
                ...current[i],
                username: e.target.value
            }
            return [...current];
        })
    }

    const onPositionEdit = (e, i) => {
        setTopDonators((current) => {
            if (e.target.value === '' && current[i].username === '') {
                current.splice(i, 1);
                return [...current];
            }
            current[i] = {
                ...current[i],
                position: e.target.value
            }
            return [...current];
        })
    }

    const save = () => {
        axios.post(`${REACT_APP_API_URL}/top-donators`, topDonators)
    }

    useEffect(() => {
        if (topDonators.length === 0) {
            setTopDonators((current) => {
                current.push({ username: '', position: '' })
                return [...current];
            })
        }

        const lastIndex = topDonators.length - 1;
        if (lastIndex < 0) {
            return;
        }
        if (topDonators[lastIndex].username !== '' && topDonators[lastIndex].position !== '') {
            setTopDonators((current) => {
                current.push({ username: '', position: '' })
                return [...current];
            })
        }
    }, [topDonators])

    useEffect(() => {
        axios.get(`${REACT_APP_API_URL}/fake-top-donators`).then((res) => {
            setTopDonators(res.data)
        })
    }, [REACT_APP_API_URL])

    if (decodedToken?.role === 1) {
        return (
            <div className="container product-section">
                <div className="shop-section">
                    <AdminNav />
                    <Button onClick={save}>Save</Button>
                    <table style={{ marginTop: '50px' }}>
                        <thead>
                            <tr><td>Username</td><td>Position</td> </tr>
                        </thead>
                        <tbody>
                            {topDonators.map((donator, i) => (
                                <tr key={i}>
                                    <td>
                                        <CssTextField value={donator.username} onInput={(e) => onUsernameEdit(e, i)}></CssTextField>
                                    </td>
                                    <td>
                                        <CssTextField value={donator.position} onInput={(e) => onPositionEdit(e, i)}></CssTextField>
                                    </td>
                                </tr>)
                            )}
                        </tbody>
                    </table>


                </div>
            </div >
        )
    } else {
        return (<NotFoundPage />)
    }
}

export default TopDonators